import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { iconAttributes } from '@/utils/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'Telegram',
  setup(__props) {

const attrs = iconAttributes({ width: 16, height: 16 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.5463 1.46069L13.1666 13.4588C13.1666 13.4588 12.8338 14.2909 11.9186 13.8915L6.42698 9.6813L4.43012 8.71618L1.06863 7.58451C1.06863 7.58451 0.552764 7.40152 0.502801 7.00213C0.452942 6.60274 1.08529 6.38644 1.08529 6.38644L14.4479 1.14447C14.4479 1.14447 15.5463 0.661905 15.5463 1.46069Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.00495 13.3239C6.00495 13.3239 5.84465 13.3089 5.64491 12.6765C5.44526 12.0441 4.43018 8.71597 4.43018 8.71597L12.501 3.59058C12.501 3.59058 12.967 3.30767 12.9504 3.59058C12.9504 3.59058 13.0335 3.64044 12.7839 3.8734C12.5343 4.10645 6.44369 9.58128 6.44369 9.58128",
      fill: "#D2E5F1"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.53286 11.2987L6.36049 13.2794C6.36049 13.2794 6.1907 13.4082 6.00488 13.3275L6.42087 9.64844",
      fill: "#B5CFE4"
    }, null, -1)
  ]), 16))
}
}

})